/* eslint-disable import/prefer-default-export */
import PropTypes from 'prop-types';
import React from 'react';

import { Button, Spacer, TranslationProvider } from '@resy/ui-kitchen';
import ModalMessages from '../ModalMessages';

const getErrorMsg = (error) => {
  if (typeof error === 'string') {
    return error;
  }
  let e;
  if (typeof error === 'object') {
    e = error?.message || error?.msg;
  }
  return e || 'There was a problem with your order. Please try again.';
};

const Error = ({
  ctaText,
  ctaTextKey,
  error,
  onClick,
}) => (
  <ModalMessages className="Error">
    <div>
      {getErrorMsg(error)}
    </div>
    <Spacer height="35" />
    <Button onClick={onClick}>
      <TranslationProvider translationKey={ctaTextKey || 'edit_order'}>
        <div>{ctaText || 'Edit Order'}</div>
      </TranslationProvider>
    </Button>
  </ModalMessages>
);

Error.propTypes = {
  ctaText: PropTypes.string,
  ctaTextKey: PropTypes.string,
  error: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      message: PropTypes.string,
    }),
  ]),
  onClick: PropTypes.func,
};

Error.defaultProps = {
  ctaText: undefined,
  ctaTextKey: undefined,
  error: undefined,
  onClick: () => {},
};

export default Error;
